export const getActivityCodeDescendants = (activityCode, childrenMap) => {
	const descendants = {};
	const stack = [activityCode];
	while (stack.length) {
		const code = stack.shift();
		if (code !== activityCode) {
			descendants[code] = true;
		}
		if (code in childrenMap) {
			for (const childCode in childrenMap[code]) {
				stack.push(childCode);
			}
		}
	}
	return descendants;
};

export const getActivityCodeAncestors = (activityCode, parentsMap) => {
	const ancestors = {};
	let current = activityCode;
	while (parentsMap[current] !== 'ROOT_NODE') {
		ancestors[parentsMap[current]] = true;
		current = parentsMap[current];
	}
	return ancestors;
};